import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
    postPaymentSubscriptionRoute,
    errorMessage,
    currentPlanKey,
    postEnterprisePaymentSubscriptionRoute,
} from '@features/payments';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type useUpdateEnterpricePaymentPlansProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
    onSuccess?: () => void;
};

export const useUpdateEnterpricePaymentPlans = ({
    setErrorText = () => { },
    onSuccess = () => { },
}: useUpdateEnterpricePaymentPlansProps) => {
    const client = useQueryClient();

    const { mutate: updateEnterprisePaymentPlan, isLoading: isUpdatingEnterprisePaymentPlan } =
        useMutation({
            mutationFn: (variables: { plan: string; token?: string }) =>
                axiosInstance
                    .post(postEnterprisePaymentSubscriptionRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    onSuccess();
                    client.invalidateQueries(currentPlanKey);
                    client.invalidateQueries(profileKey);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        updateEnterprisePaymentPlan,
        isUpdatingEnterprisePaymentPlan,
    };
};
